import { render, staticRenderFns } from "./RemoteWaterMeter.vue?vue&type=template&id=febf792a&scoped=true"
import script from "./RemoteWaterMeter.vue?vue&type=script&lang=js"
export * from "./RemoteWaterMeter.vue?vue&type=script&lang=js"
import style0 from "./RemoteWaterMeter.vue?vue&type=style&index=0&id=febf792a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf792a",
  null
  
)

export default component.exports